import { render, staticRenderFns } from "./CardPatient.vue?vue&type=template&id=2eb8c0bb&scoped=true&"
import script from "./CardPatient.vue?vue&type=script&lang=js&"
export * from "./CardPatient.vue?vue&type=script&lang=js&"
import style0 from "./CardPatient.vue?vue&type=style&index=0&id=2eb8c0bb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eb8c0bb",
  null
  
)

export default component.exports